import { render } from "./CasesChart.vue?vue&type=template&id=a3e0111c"
import script from "./CasesChart.vue?vue&type=script&lang=js"
export * from "./CasesChart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__